/** API 認証に失敗した場合のエラー */
export class ApiAuthenticationFailedException extends Error {
  readonly category: string
  constructor(category: string) {
    super('API authentication failed.')
    this.category = category
  }
}

/** API Passphrase が必須だが定義されていない場合のエラー */
export class ApiPassphraseRequiredException extends Error {
  constructor() {
    super('API Passphrase is required but not defined.')
  }
}

/** API Secret が必須だが定義されていない場合のエラー */
export class ApiSecretRequiredException extends Error {
  constructor() {
    super('API Secret is required but not defined.')
  }
}

/** symbol に一致する asset が見つからない場合のエラー */
export class AssetNotFoundException extends Error {
  constructor(symbol: string) {
    super(`Asset not found for symbol: ${symbol}`)
  }
}

/** subType が必須だが定義されていない場合のエラー */
export class SubTypeRequiredException extends Error {
  constructor() {
    super('SubType is required but not defined.')
  }
}
